module.exports = __webpack_public_path__ + "img/InvitaYgana_cont.2d7f9f39.png";